import React, { Component } from "react";
import { Messages } from "../../components/features/Messages";
import { withRouter } from "react-router-dom";
import moment from "moment-timezone";

class MessagesContainer extends Component {
  state = {
    messages: [],
    messagesLoaded: false,
    message: "",
    name: "",
    submitDisabled: false,
    deleteConfirm: false
  };

  UNSAFE_componentWillMount = () => {
    this.unsubscribe = window.firebase
      .firestore()
      .collection("features")
      .doc(this.props.featureId)
      .collection("messages")
      .onSnapshot(querySnapshot => {
        let messages = [];
        querySnapshot.forEach(function(doc) {
          let message = doc.data();
          message[".key"] = doc.id;
          messages.push(message);
        });
        messages = messages
          .filter(message => message.deleted === undefined)
          .sort((a, b) => a.date - b.date);
        this.setState({ messages: messages, messagesLoaded: true });
      });
  };

  componentWillUnmount = () => {
    this.unsubscribe();
  };

  handleChange = e => {
    let toUpdate = {};
    toUpdate[e.target.name] = e.target.value;
    this.setState(toUpdate);
  };

  handleSubmitMessage = e => {
    e.preventDefault();
    if (this.state.submitDisabled === false) {
      this.setState({ submitDisabled: true });
      window.firebase
        .firestore()
        .collection("features")
        .doc(this.props.featureId)
        .collection("messages")
        .doc()
        .set({
          message: this.state.message,
          uid: this.props.user.uid,
          date: moment().unix(),
          name: this.state.name
        })
        .then(() => {
          this.setState({ message: "", name: "", submitDisabled: false });
        });
    }
  };

  handleDelete = (e, messageId) => {
    if (this.state.deleteConfirm) {
      window.firebase
        .firestore()
        .collection("features")
        .doc(this.props.featureId)
        .collection("messages")
        .doc(messageId)
        .update({ deleted: true });
      this.setState({ deleteConfirm: false });
    } else {
      this.setState({ deleteConfirm: messageId });
    }
  };

  render() {
    return (
      <Messages
        messages={this.state.messages}
        handleSubmitMessage={this.handleSubmitMessage}
        handleChange={this.handleChange}
        message={this.state.message}
        name={this.state.name}
        admins={this.props.admins}
        deleteConfirm={this.state.deleteConfirm}
        handleDelete={this.handleDelete}
        isAdmin={this.props.isAdmin}
      />
    );
  }
}

export default withRouter(MessagesContainer);
